const calculateTotalAmount = (table: any[], tableFieldName: string): number => {
    let totalAmount = 0;
    table.forEach((item: any) => {
            totalAmount += item[tableFieldName];
        }
    );
    return totalAmount;
};
export const DocumentCalculationsHelper = {
    calculateTotalAmount
}